<div class="responsive-container">
  <!-- Table View -->
  <ng-template #subroutesTemplate>
    <ng-content select="[slot=subroutes]"></ng-content>
  </ng-template>

  <ng-template #filtersTemplate>
    <ng-content select="[slot=filters]"></ng-content>
  </ng-template>

  
  <ng-container *ngIf="!isMobile; else mobileView">
    <div class="submenu-wrapper filter-container-responsive" *ngIf="hasFilters">
      <div class="grid grid-no-tb-gutter flex justify-content-between">
        <div class="col flex align-content-center flex-wrap flex-w-auto filter-pod-container">
          <ng-container *ngTemplateOutlet="subroutesTemplate"></ng-container>
        </div>
        
        <div class="col flex align-content-center flex-w-auto">
          <div class="grid align-content-center p-30">
            <div *ngIf="hideTable && barType == HorizontalBarType.Interaction">
              <bpc-dc-company-dropdown (onChange)="filterData($event, FilterType.DcCompany)"></bpc-dc-company-dropdown>
            </div>
            <div *ngIf="hasPod">
              <bpc-pods-dropdown  #podsDropdown [includeCompaniesPod]="true" (onChange)="filterData($event, FilterType.Pod)" />
            </div>
            <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
            <ng-content select="[slot=header-options]"></ng-content>
          </div>
        </div>
      </div>
    </div>

    <bpc-horizontal-bar *ngIf="barType !== HorizontalBarType.None" [type]="barType" [loading]="barLoading" [useOldVersion]="false" [data]="barData" (onSelection)="filterData($event, FilterType.Bar)" [dataLoading]="isLoading" />

    <ng-container *ngIf="!hideTable">
      <bpc-dynamic-table [tableClass]="tableClass" [enableSelection]="enableSelection" [data]="data" [columns]="columns" [pageSize]="100" [totalCount]="totalCount" [loading]="isLoading" [DataFilter]="companiesFilter" (onColumnSortClickEmitter)="onColumnSortClick($event)" (onSelectionChange)="onCheckboxSelectionChange($event)">
        <bpc-paginator *ngIf="shouldShowPagination" [totalCount]="totalCount" [loading]="isLoading" (onPageChange)="onPageChange($event)" (onPageSizeChange)="onPageSizeChange($event)"/>
      </bpc-dynamic-table>
    </ng-container>
  </ng-container>
  

  <!-- Card View -->
  <ng-template #mobileView>
    <div class="search-container" *ngIf="hasPod">
      <input #searchInput
      type="text" 
      pInputText 
      placeholder="Search" 
      (keydown.arrowDown)="$event.preventDefault()"
      (keydown.arrowUp)="$event.preventDefault()"
      (keydown.enter)="filterData($event, FilterType.Search)" 
      inputmode="search" 
      [(ngModel)]="searchQuery"/>
    </div>
    <div class="sticky-bar">
      <div class="sticky-bar-left">
        <span>{{title}}</span>
      </div>
      <div *ngIf="hasPod" class="sticky-bar-right">
        <a
        class="lbl-clear-filter"
        title="Clear All"
        (click)="filterData({target:{value:''}}, FilterType.Search)"
        *ngIf="companiesFilter.companyName != null && companiesFilter.companyName[0] != ''"
        >Clear Search</a
      >
        <i class="pi pi-filter filter-icon" [ngClass]="hasPodSelected? 'active': 'inactive'"
          (click)="toggleFilter()"></i>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="subroutesTemplate"></ng-container>
    <div class="filters">
      <bpc-horizontal-bar *ngIf="barType !== HorizontalBarType.None && barData.length > 0" [useOldVersion]="false" [data]="barData" [loading]="barLoading" (onSelection)="filterData($event, FilterType.Bar)" />
        <div [hidden]="!hasPodSelected">
          <div class="filter-container stage-dropdown-container">
            <bpc-pods-dropdown #podsDropdown [includeCompaniesPod]="true" (onChange)="filterData($event, FilterType.Pod)" />
          </div>
        </div>
    </div>

    <div style="padding-bottom: 175px; background-color: #ffffff;">
      <bpc-dynamic-cards [data]="data" [loading]="isLoading" />
      
      <span *ngIf="totalCount > data.length" class="load-more" (click)="loadMoreData()">
        <h1 *ngIf="!isLoading">Load More...</h1>
      </span>
    </div>
  </ng-template>
</div>
